import { z } from 'zod';
import { BaseMaterialQuoteSchema, MaterialControlPropertiesSchema } from './material-quote.ts';

export const GetMaterialQuoteUrlSchema = z.strictObject({
    id: z.string().uuid(),
});

export const GetMaterialQuoteResponseSchema = BaseMaterialQuoteSchema.and(MaterialControlPropertiesSchema);
